import { Vector3 } from "../maths/Vector3";
import { Pool } from "../utils/Pool";
export var CurveType;
(function (CurveType) {
    CurveType[CurveType["CRSpline"] = 0] = "CRSpline";
    CurveType[CurveType["Bezier"] = 1] = "Bezier";
    CurveType[CurveType["CubicBezier"] = 2] = "CubicBezier";
    CurveType[CurveType["Straight"] = 3] = "Straight";
})(CurveType || (CurveType = {}));
export class PathPoint {
    constructor() {
        this.pos = new Vector3();
        this.c1 = new Vector3();
        this.c2 = new Vector3();
        this.curve = 0;
    }
    static create(x, y, z, curve) {
        let pt = pool.take();
        pt.pos.set(x, y, z);
        pt.curve = curve || 0;
        return pt;
    }
    recover() {
        pool.recover(this);
    }
    clone() {
        let pt = pool.take();
        this.pos.cloneTo(pt.pos);
        this.c1.cloneTo(pt.c1);
        this.c2.cloneTo(pt.c2);
        pt.curve = this.curve;
        return pt;
    }
    _reset() {
        this.pos.set(0, 0, 0);
        this.c1.set(0, 0, 0);
        this.c2.set(0, 0, 0);
        this.curve = 0;
    }
}
const pool = Pool.createPool(PathPoint, null, e => e._reset());
